// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__hMrtw","detailsBorder":"styles_detailsBorder__xeDdP"};